module.exports = __webpack_public_path__ + "static/media/fa-solid-900.333bae20.woff";